<template>
  <v-container pa-3>
    <v-layout align-center justify-center column>
      <v-flex xs12 md8 lg6>
        <h3 class="display-1 mb-3 mt-5 text-xs-center">
          What our clients say...
        </h3>
        <testimonial
          v-for="(testimonial, i) in testimonials"
          :key="i"
          :testimonial="testimonial"
        ></testimonial>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
import Testimonial from './Testimonial';

export default {
  name: 'TheHomePageTestimonials',
  components: { Testimonial },
  data() {
    return {
      length: 3,
      window: 0,
      testimonials: [
        {
          value: 5,
          message:
            "Phil was a pleasure to work with. I don't have a lot of experience with real estate other than buying my first original property years ago, and I had a lot of concerns with this transaction since this was a second property away from home. Phil was open, honest, a straight shooter, and was easy to communicate with. He eased any stress that I had and we were able to complete everything easily in a minimal amount of time. I highly recommend Phil and look forward to working with him again in the future.",
          title: 'Midrise Condo Purchase',
          author: 'Blaine',
        },
        {
          value: 5,
          message:
            "Very knowledgeable of all aspects of the process! Phil is a great agent. He is friendly, really easy to work with, and really knows his market. He's always willing to answer questions and is happy to explain anything. He makes himself available at all times to help his customers. He stays on top of your account, giving it personal attention, making sure it moves along. He makes sure everyone else (lender, the other agent) does not slack off. This was my first time using him for my purchase and I will definitely use him for my future transactions. If you want your transaction to go as fast and as smooth as possible you should give Phil a call.",
          title: 'Phil was great',
          author: 'Sean',
        },
        {
          value: 5,
          message:
            "My Experience in buying my first home in Las Vegas was smooth and painless. Philip Roy is a very Hardworking professional  who will always be straight forward with you and never cut corners. He is a very down to earth person that can teach you a lot of things about the real estate market. I highly recommend him because you can trust him and walk away happy knowing your in good hands. I'm very happy with my new home because of Phillip Roy. I would've settled for less if it wasn't for him. He guided me through the steps correctly and pushed me until I found something worthy on the market. Overall, my experience with Phillip Roy was awesome and highly recommend him.",
          title: 'My First Home Purchase',
          author: 'Ryan',
        },
      ],
    };
  },
};
</script>
